module.exports = __webpack_public_path__ + "img/compressed-1978262934782087168.0c6f03a2.png";